import type { HomePageFundRecord } from '@domain/landing/homePageFundPayload'
import type { StrapiComponent, StrapiFundData } from '@types'

type Fund = StrapiComponent<StrapiFundData> | HomePageFundRecord

export type WlthEntryCurrentChange = {
  entry: number
  current: number
  percent: number
}

/**
 * Same formula as PreIpoFundListItem: (currentValuation - referenceValue) / referenceValue.
 * Never marketplace / lowest in-app listing. Skip if either number is missing or entry is 0.
 */
export function getWlthEntryCurrentChange(
  referenceValue: string | number | null | undefined,
  currentValuation: string | number | null | undefined,
): WlthEntryCurrentChange | null {
  const entry = Number(referenceValue)
  const current = Number(currentValuation)
  if (!Number.isFinite(entry) || !Number.isFinite(current) || entry === 0) {
    return null
  }
  return {
    entry,
    current,
    percent: ((current - entry) / entry) * 100,
  }
}

export function formatWlthGainPct(percent: number) {
  const rounded = Math.round(percent)
  return `${rounded > 0 ? '+' : ''}${rounded}%`
}

export function getFundEntryCurrentChange(fund: Fund) {
  return getWlthEntryCurrentChange(
    fund.referenceValue,
    fund.communityFundCustomData?.currentValuation,
  )
}
